
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as tipsJFUCQG02VUCkJGu0NI82LieL_I2xbxweSYM3i_45S8gXMMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/tips.vue?macro=true";
import { default as index305A3G648n8CI_XOYlUcyBMJ6ul26fTzFwbFWral8cEMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/index.vue?macro=true";
import { default as login6FtH76PgjT5G3Qi3546ZW5rCfNgK7Cto7d8N167V8XkMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/login.vue?macro=true";
import { default as FeaturesNIzUU_45b5alUUMEymWDv2TuqsHZoi0DTKt2X5WlzdhcAMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/Features.vue?macro=true";
import { default as dashboarddU4_cK9e_45F_45U8h_aSc1nzICuHMCRj_456DdM3kZt_HCpMMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/dashboard.vue?macro=true";
import { default as all0ztGEvD5LaSypLAeaBnTD28rXk5zWN_TDOTgwCPJMjUMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/my-waste/all.vue?macro=true";
import { default as indexngQybEkAJgQNPSeEVl6NiFCkhTNydxgyhmASdP6At_kMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/profile/index.vue?macro=true";
import { default as indexjIxrBztSIAm1HYEK_45hHjjp77c_r0WnjVelblacfRV3QMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/my-waste/index.vue?macro=true";
import { default as Feesjl3g66dOkavyG_mSVvc2C03E_Fhy6KXQFRCDVBYVbrMMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/Fees.vue?macro=true";
import { default as invoicestJsExHjRuaZhgU_45OwCaw7rJp9PK5WSbnPnlA_45P8QPYkMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/profile/invoices.vue?macro=true";
import { default as my_45unsorted_45wasteRH314yrWxkT_45_n0O7AaUQHyqWc510UfeueAsjlXFMiQMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/my-unsorted-waste.vue?macro=true";
import { default as Footerc7oObNB1hKvSY5RSoy_45N7cE8jiK_45FYtkFxAJJuVphZ4Meta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/Footer.vue?macro=true";
import { default as IconInfoHuoqAMD8tEfgbvi_BLCHxuztjsfHBglFYxF0ZPRd_LcMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/IconInfo.vue?macro=true";
import { default as WasteCardAQzCFhl9I4W7uZeA2vVF85rpGuvTqi5y3qRw2_Tzb9gMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/WasteCard.vue?macro=true";
import { default as indexuwoLRz2ZaweXQ7yH4VEbGGWwJirB2vm7UzbQydYQeVwMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-yard/index.vue?macro=true";
import { default as notifications9psBdoqozOh3LO5GpYBYbQZkceYULhkLpTLemxMUhjkMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/profile/notifications.vue?macro=true";
import { default as indexEM4JfOxpZkJdOuyThiZ6nmq7m7NZJFjSz9wrfllZc_45wMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-point/index.vue?macro=true";
import { default as all_45binsTb0L1p6HjQ8TGMxNhzuAUrX75bAseuw8ITnRoRjKc_45AMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-point/all-bins.vue?macro=true";
import { default as all_45visitsYYJjWBS1vyIOTvpBsFCChRSdkHtRTD7_JqMh4gcQiVYMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-yard/all-visits.vue?macro=true";
import { default as calculationD_45IU_KNw0a68GQcKig8D4q3F5Q5ItPWh8lm5t8rRH_YMeta } from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-point/calculation.vue?macro=true";
export default [
  {
    name: "tips",
    path: "/tips",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/tips.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index305A3G648n8CI_XOYlUcyBMJ6ul26fTzFwbFWral8cEMeta || {},
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login6FtH76PgjT5G3Qi3546ZW5rCfNgK7Cto7d8N167V8XkMeta || {},
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/login.vue")
  },
  {
    name: "Features",
    path: "/Features",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/Features.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/dashboard.vue")
  },
  {
    name: "my-waste-all",
    path: "/my-waste/all",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/my-waste/all.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/profile/index.vue")
  },
  {
    name: "my-waste",
    path: "/my-waste",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/my-waste/index.vue")
  },
  {
    name: "_components-Fees",
    path: "/_components/Fees",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/Fees.vue")
  },
  {
    name: "profile-invoices",
    path: "/profile/invoices",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/profile/invoices.vue")
  },
  {
    name: "my-unsorted-waste",
    path: "/my-unsorted-waste",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/my-unsorted-waste.vue")
  },
  {
    name: "_components-Footer",
    path: "/_components/Footer",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/Footer.vue")
  },
  {
    name: "_components-IconInfo",
    path: "/_components/IconInfo",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/IconInfo.vue")
  },
  {
    name: "_components-WasteCard",
    path: "/_components/WasteCard",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/_components/WasteCard.vue")
  },
  {
    name: "collection-yard",
    path: "/collection-yard",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-yard/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/profile/notifications.vue")
  },
  {
    name: "collection-point",
    path: "/collection-point",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-point/index.vue")
  },
  {
    name: "collection-point-all-bins",
    path: "/collection-point/all-bins",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-point/all-bins.vue")
  },
  {
    name: "collection-yard-all-visits",
    path: "/collection-yard/all-visits",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-yard/all-visits.vue")
  },
  {
    name: "collection-point-calculation",
    path: "/collection-point/calculation",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/pages/collection-point/calculation.vue")
  }
]